import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCourseraContents } from "../../slices/courseraSlice";
import { LoadingOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Avatar } from "antd";

const data = [
  {
    title: "UX Designer",
  },
  {
    title: "UX Designer",
  },
];

function RecommendedCard({ onDragStart, onDragStop }) {
  console.log({ onDragStart });
  console.log({ onDragStop });
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(3);
  const [start, setStart] = useState(0);
  const courseData = useSelector((state) => state.coursera.courseData);
  const [resData, setResData] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(true);
    dispatch(getCourseraContents({ start: start, limit: limit })).then(
      (res) => {
        const data = res?.payload?.data?.elements;
        const newData = resData?.concat(data);
        setResData(newData);
        console.log("🚀 ~ dispatsch ~ res:", res?.payload?.data?.elements);
        setLoading(false);
      }
    );
  }, [start, limit]);

  console.log({ resData });
  return (
    <div className="rounded-2xl p-5 shadow-shadowOne bg-pureWhite overflow-auto h-full ">
      <h2 className="font-semibold text-lg">Recommended Course</h2>
      <div className="space-y-4 my-2 z-50">
        {resData?.length > 0 &&
          resData?.map((items, i) => {
            return (
              <div key={i} className="bg-lightGrey p-4 rounded-3xl">
                <div className="flex justify-between my-2">
                  <p className="text-sm text-gray-600">
                    Level: {items?.difficultyLevel}
                  </p>
                </div>
                <div className="flex items-center space-x-4 ">
                  <div className="rounded-full bg-gray-400 ">
                    <Avatar
                      src={items?.extraMetadata?.definition?.promoPhoto}
                      size={"large"}
                    />
                  </div>
                  <div className="flex-grow">
                    <h3 className="text-lg font-medium">{items?.name}</h3>
                    <p className="text-sm text-gray-600">
                      {items?.partners?.length > 0 && items?.partners[0]?.name}
                    </p>
                  </div>
                  <div className="text-center ">
                    <button className="bg-buttonGradient w-[100px] mb-3 text-white rounded-3xl px-4 py-2">
                      <Link
                        target="_blank"
                        to={
                          items?.programs?.length > 0
                            ? items?.programs[0]?.contentUrl
                            : ""
                        }
                      >
                        Enroll
                      </Link>
                    </button>
                    <p className="text-xs text-gray-500">2 Hours ago</p>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default RecommendedCard;